__webpack_require__.p = "https://campaign-editor-frontend.studyportals.eu/dist/";